import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

import Color from 'helpers/Color'

const Item = styled(NavLink)`
  color: inherit;
  font-style: sans-serif;
  font-size: 1.4em;
  font-weight: bold;
  margin-right: 15px;

  &.active {
    border-bottom: solid 4px ${Color.green};
  }

  &:hover {
    color: ${Color.green};
  }

  &:not(:last-child)::after {
    content: '>';
    margin-left: 15px;
    color: ${Color.darkGray};
  }
`

const Breadcrumbs = ({ items }) => (
  <div>
    { items.map((item, index) => (
      <Item
        key={index}
        to={item.to}
        exact
      >
        {item.name}
      </Item>
    ))}
  </div>
)

export default Breadcrumbs



// WEBPACK FOOTER //
// ./src/components/UI/Breadcrumbs.jsx